import { styled } from '@mui/material';
import { grey } from '@mui/material/colors';

export const RecognitionControls = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginBottom: '0.5rem',
  height: '2.2rem',
});

export const RecognitionProgress = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  flexGrow: 1,
});

export const RecognitionProgressBar = styled('div')({
  flexGrow: 1,
});

export const RecognitionProgressIndicator = styled('div')({
  flexShrink: 0,
  color: grey[600],
});

export const RecognitionFitness = styled('div')({
  flexShrink: 0,
  width: '5rem',
});

export const RecognitionLineChart = styled('div')({
  position: 'relative',
});
